export const RESULTS_LIMIT = 3;
export const MIN_SCORE_THRESHOLD = 0.3;
